export default __webpack_public_path__ + "static/media/013-avalanche.ccffcac3.svg";